import {useContext} from "react";
import {PopupContext} from "../providers/PopupProvider";


export const usePopup: Function = () => {
    return useContext(PopupContext);
};